import React from 'react';

import { TagStatusLight, type TagStatusLightProps } from '@clubspark-react/ui/core';

import { playerStatus } from 'constants/playerStatus';

interface EventPlayerStatusProps {
  status: keyof typeof playerStatus;
  short: boolean;
}

const getStatusVariant = (playerStatus?: EventPlayerStatusProps['status']): TagStatusLightProps['variant'] => {
  switch (playerStatus) {
    case 'DIRECT_ACCEPTANCE':
      return 'highlight1Outline';
    case 'SPECIAL_EXEMPT':
      return 'pendingOutline';
    case 'JUNIOR_EXEMPT':
      return 'pendingOutline';
    case 'WILDCARD':
      return 'successOutline';
    case 'ALTERNATE':
      return 'warningOutline';
    case 'QUALIFIER':
      return 'highlight2Outline';
  }
  return 'pendingOutline';
};

export const EventPlayerStatus: React.FC<React.PropsWithChildren<EventPlayerStatusProps>> = React.memo(
  ({ status, short = true }) => {
    const { name, abbrv } = playerStatus[status] ?? {};
    const variant = getStatusVariant(status);

    return (
      <>
        {/* @ts-expect-error TextProps not extending span properly */}
        <TagStatusLight sx={{ margin: '1px' }} title={name} variant={variant}>
          {short ? abbrv : name}
        </TagStatusLight>
      </>
    );
  },
);
